module.exports = "/_next/static/images/PowerYourApps-d8fa6ad84f1043beb67061cf9a6db9bd.webp";